/**
 * Карусель «Преимущества» для #block4.secondary-advantages (начальная / средняя / старшая).
 * Логика как у kindergartenAdvantagesSlider.js: центрирование, клоны, свайп.
 */
(function() {
  "use strict";

  var GAP = 20;
  var MOBILE_CARD_WIDTH = 300;

  /* Состояние на уровне модуля: при ложном resize (адресная строка и т.п.) не сбрасывать слайд */
  var advantagesCurrentIdx = 0;
  var advantagesIsTransitioning = false;
  var advantagesIsAnim = false;
  var lastAdvantagesResizeWidth = null;

  function getSection() {
    var el = document.getElementById("block4");
    if (!el || !el.classList.contains("secondary-advantages")) return null;
    return el;
  }

  function getItemWidth() {
    return MOBILE_CARD_WIDTH;
  }

  function getStep() {
    return getItemWidth() + GAP;
  }

  /** Горизонтальное смещение ленты относительно .container_advange (иначе при text-align:center + width:fit-content центр считается неверно). */
  function gridLayoutInsetLeft(grid, container) {
    if (!grid || !container || !container.contains(grid)) return 0;
    var inset = 0;
    var el = grid;
    while (el && el !== container) {
      inset += el.offsetLeft;
      el = el.offsetParent;
    }
    return el === container ? inset : 0;
  }

  function getDuration() {
    return window.innerWidth >= 1024 ? "0.2s" : "0.4s";
  }

  function getDurationMs() {
    return window.innerWidth >= 1024 ? 200 : 400;
  }

  /** Только translate — без смены индекса; для resize при той же ширине окна (как secondaryHeroFeaturesSlider). */
  function repositionSecondaryAdvantagesGrid(grid, container) {
    if (!grid || !container || window.innerWidth > 768) return;
    var real = Array.prototype.filter.call(
      grid.querySelectorAll(".advantage_card"),
      function(el) {
        return !el.classList.contains("advantage-card-clone");
      }
    );
    if (!real.length) return;
    if (advantagesCurrentIdx < 0) advantagesCurrentIdx = 0;
    if (advantagesCurrentIdx >= real.length) advantagesCurrentIdx = real.length - 1;

    var cRect = container.getBoundingClientRect();
    var cLeft = cRect.left;
    var centerX = cLeft + cRect.width / 2;
    var gridInset = gridLayoutInsetLeft(grid, container);
    var step = getStep();
    var iw = getItemWidth();
    var domIdx = real.length + advantagesCurrentIdx;
    var tx = centerX - cLeft - gridInset - (domIdx * step + iw / 2);
    grid.style.transform = "translateX(" + tx + "px)";
  }

  function equalizeBottomCardHeights(section) {
    if (window.innerWidth > 768 || !section) return;
    var bottomCards = section.querySelectorAll(
      ".advantage_card_bottom:not(.advantage-card-clone)"
    );
    if (!bottomCards.length) return;
    bottomCards.forEach(function(card) {
      card.style.height = "auto";
    });
    var maxH = 0;
    bottomCards.forEach(function(card) {
      var h = card.offsetHeight;
      if (h > maxH) maxH = h;
    });
    section.querySelectorAll(".advantage_card_bottom").forEach(function(card) {
      card.style.height = maxH ? maxH + "px" : "auto";
    });
  }

  function initSchoolAdvantagesSlider() {
    var section = getSection();
    if (!section) return;

    var container = section.querySelector(".container_advange");
    var grid = container ? container.querySelector(".advantages_grid") : null;
    if (!container || !grid) return;

    if (window.innerWidth > 768) {
      var hadBound = grid.getAttribute("data-school-advantages-bound") === "1";
      grid.querySelectorAll(".advantage-card-clone").forEach(function(c) {
        c.remove();
      });
      grid.style.transform = "";
      grid.style.transition = "";
      grid.classList.remove("dragging");
      grid.removeAttribute("data-school-advantages-bound");
      section.querySelectorAll(".advantage_card_bottom").forEach(function(card) {
        card.style.height = "";
      });
      if (hadBound && grid.parentNode) {
        var freshGrid = grid.cloneNode(true);
        grid.parentNode.replaceChild(freshGrid, grid);
      }
      return;
    }

    function getRealItems() {
      return Array.prototype.filter.call(
        grid.querySelectorAll(".advantage_card"),
        function(el) {
          return !el.classList.contains("advantage-card-clone");
        }
      );
    }

    function cloneItems() {
      grid.querySelectorAll(".advantage-card-clone").forEach(function(c) {
        c.remove();
      });
      if (window.innerWidth > 768) return;

      var real = getRealItems();
      if (!real.length) return;

      var fragBefore = document.createDocumentFragment();
      real.forEach(function(item) {
        var cl = item.cloneNode(true);
        cl.classList.add("advantage-card-clone");
        fragBefore.appendChild(cl);
      });
      grid.insertBefore(fragBefore, real[0]);

      real.forEach(function(item) {
        var cl = item.cloneNode(true);
        cl.classList.add("advantage-card-clone");
        grid.appendChild(cl);
      });
    }

    function updatePos() {
      if (!grid || !container || window.innerWidth > 768) return;
      var real = getRealItems();
      if (!real.length) return;
      if (advantagesCurrentIdx < 0) advantagesCurrentIdx = 0;
      if (advantagesCurrentIdx >= real.length) advantagesCurrentIdx = real.length - 1;

      var cRect = container.getBoundingClientRect();
      var cLeft = cRect.left;
      var centerX = cLeft + cRect.width / 2;
      var gridInset = gridLayoutInsetLeft(grid, container);
      var step = getStep();
      var iw = getItemWidth();
      var domIdx = real.length + advantagesCurrentIdx;
      var tx = centerX - cLeft - gridInset - (domIdx * step + iw / 2);

      if (!advantagesIsTransitioning) {
        grid.style.transition =
          "transform " + getDuration() + " cubic-bezier(0.4,0,0.2,1)";
      }
      grid.style.transform = "translateX(" + tx + "px)";
    }

    function getInitTx() {
      var real = getRealItems();
      if (!real.length) return 0;
      var cRect = container.getBoundingClientRect();
      var cLeft = cRect.left;
      var centerX = cLeft + cRect.width / 2;
      var gridInset = gridLayoutInsetLeft(grid, container);
      var step = getStep();
      var iw = getItemWidth();
      var domIdx = real.length;
      return centerX - cLeft - gridInset - (domIdx * step + iw / 2);
    }

    function goNext() {
      if (advantagesIsTransitioning || advantagesIsAnim || window.innerWidth > 768) return;
      var real = getRealItems();
      if (advantagesCurrentIdx < real.length - 1) {
        advantagesIsAnim = true;
        advantagesCurrentIdx++;
        updatePos();
        setTimeout(function() {
          advantagesIsAnim = false;
        }, getDurationMs());
      } else {
        advantagesIsTransitioning = true;
        advantagesIsAnim = true;
        var step = getStep();
        var iw = getItemWidth();
        var cloneIdx = real.length * 2;
        var cRect = container.getBoundingClientRect();
        var centerX = cRect.left + cRect.width / 2;
        var gridInset = gridLayoutInsetLeft(grid, container);
        var tx = centerX - cRect.left - gridInset - (cloneIdx * step + iw / 2);
        grid.style.transition =
          "transform " + getDuration() + " cubic-bezier(0.4,0,0.2,1)";
        grid.style.transform = "translateX(" + tx + "px)";
        setTimeout(function() {
          grid.style.transition = "none";
          advantagesCurrentIdx = 0;
          updatePos();
          requestAnimationFrame(function() {
            setTimeout(function() {
              advantagesIsTransitioning = false;
              advantagesIsAnim = false;
              grid.style.transition =
                "transform " + getDuration() + " cubic-bezier(0.4,0,0.2,1)";
            }, 1);
          });
        }, getDurationMs());
      }
    }

    function goPrev() {
      if (advantagesIsTransitioning || advantagesIsAnim || window.innerWidth > 768) return;
      var real = getRealItems();
      if (advantagesCurrentIdx > 0) {
        advantagesIsAnim = true;
        advantagesCurrentIdx--;
        updatePos();
        setTimeout(function() {
          advantagesIsAnim = false;
        }, getDurationMs());
      } else {
        advantagesIsTransitioning = true;
        advantagesIsAnim = true;
        var step = getStep();
        var iw = getItemWidth();
        var cloneIdx = real.length - 1;
        var cRect = container.getBoundingClientRect();
        var centerX = cRect.left + cRect.width / 2;
        var gridInset = gridLayoutInsetLeft(grid, container);
        var tx = centerX - cRect.left - gridInset - (cloneIdx * step + iw / 2);
        grid.style.transition =
          "transform " + getDuration() + " cubic-bezier(0.4,0,0.2,1)";
        grid.style.transform = "translateX(" + tx + "px)";
        setTimeout(function() {
          grid.style.transition = "none";
          advantagesCurrentIdx = real.length - 1;
          updatePos();
          requestAnimationFrame(function() {
            setTimeout(function() {
              advantagesIsTransitioning = false;
              advantagesIsAnim = false;
              grid.style.transition =
                "transform " + getDuration() + " cubic-bezier(0.4,0,0.2,1)";
            }, 1);
          });
        }, getDurationMs());
      }
    }

    var realItems = getRealItems();
    if (!realItems.length) return;

    if (grid.getAttribute("data-school-advantages-bound") === "1") {
      cloneItems();
      /* не сбрасывать advantagesCurrentIdx — сохраняем активный слайд при повторной инициализации */
      grid.style.transition = "none";
      updatePos();
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          if (grid) {
            grid.style.transition =
              "transform " + getDuration() + " cubic-bezier(0.4,0,0.2,1)";
          }
        });
      });
      setTimeout(function() {
        equalizeBottomCardHeights(section);
        /* Выровнять высоты нижних карточек может чуть сдвинуть layout — пересчитать центр без анимации */
        if (grid && container) {
          grid.style.transition = "none";
          updatePos();
          requestAnimationFrame(function() {
            requestAnimationFrame(function() {
              if (grid) {
                grid.style.transition =
                  "transform " + getDuration() + " cubic-bezier(0.4,0,0.2,1)";
              }
            });
          });
        }
      }, 100);
      return;
    }

    grid.setAttribute("data-school-advantages-bound", "1");

    cloneItems();
    advantagesCurrentIdx = 0;
    /* Один расчёт позиции: раньше был getInitTx() и через 50ms updatePos() с уже включённым transition —
       при любом расхождении после reflow (шрифты, скроллбар) карточка «плыла» к новому translate. */
    grid.style.transition = "none";
    updatePos();
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        if (grid) {
          grid.style.transition =
            "transform " + getDuration() + " cubic-bezier(0.4,0,0.2,1)";
        }
      });
    });
    setTimeout(function() {
      equalizeBottomCardHeights(section);
      if (grid && container) {
        grid.style.transition = "none";
        updatePos();
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            if (grid) {
              grid.style.transition =
                "transform " + getDuration() + " cubic-bezier(0.4,0,0.2,1)";
            }
          });
        });
      }
    }, 100);

    var isDragging = false;
    var dragStartX = 0;
    var dragStartY = 0;
    var dragCurX = 0;
    var dragInitTx = 0;

    grid.addEventListener(
      "touchstart",
      function(e) {
        if (advantagesIsTransitioning || advantagesIsAnim || window.innerWidth > 768) return;
        isDragging = true;
        dragCurX = 0;
        dragStartX = e.touches[0].clientX;
        dragStartY = e.touches[0].clientY;
        var m = (grid.style.transform || "").match(/translateX\(([^)]+)\)/);
        dragInitTx = m ? parseFloat(m[1]) : getInitTx();
        grid.classList.add("dragging");
      },
      { passive: true }
    );

    /* Логика 1:1 с kindergartenAdvantagesSlider.js: transform на каждом move, preventDefault только при явном горизонтальном жесте */
    grid.addEventListener(
      "touchmove",
      function(e) {
        if (!isDragging) return;
        var dx = e.touches[0].clientX - dragStartX;
        var dy = e.touches[0].clientY - dragStartY;
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 5) {
          e.preventDefault();
        }
        if (window.innerWidth <= 768) {
          dragCurX = dx;
          grid.style.transform = "translateX(" + (dragInitTx + dragCurX) + "px)";
        }
      },
      { passive: false }
    );

    grid.addEventListener(
      "touchend",
      function() {
        if (!isDragging) return;
        isDragging = false;
        grid.classList.remove("dragging");
        var threshold = getStep() / 6;
        if (Math.abs(dragCurX) > threshold) {
          if (dragCurX > 0) goPrev();
          else goNext();
        } else {
          updatePos();
        }
        dragCurX = 0;
      },
      { passive: true }
    );

    grid.addEventListener(
      "touchcancel",
      function() {
        if (!isDragging) return;
        isDragging = false;
        grid.classList.remove("dragging");
        updatePos();
        dragCurX = 0;
      },
      { passive: true }
    );

    grid.addEventListener("mousedown", function(e) {
      if (advantagesIsTransitioning || advantagesIsAnim || window.innerWidth > 768) return;
      isDragging = true;
      dragStartX = e.clientX;
      var m = (grid.style.transform || "").match(/translateX\(([^)]+)\)/);
      dragInitTx = m ? parseFloat(m[1]) : getInitTx();
      grid.classList.add("dragging");
      e.preventDefault();
    });

    grid.addEventListener("mousemove", function(e) {
      if (!isDragging) return;
      dragCurX = e.clientX - dragStartX;
      grid.style.transform = "translateX(" + (dragInitTx + dragCurX) + "px)";
    });

    grid.addEventListener("mouseup", function() {
      if (!isDragging) return;
      isDragging = false;
      grid.classList.remove("dragging");
      var threshold = getStep() / 6;
      if (Math.abs(dragCurX) > threshold) {
        if (dragCurX > 0) goPrev();
        else goNext();
      } else {
        updatePos();
      }
      dragCurX = 0;
    });

    grid.addEventListener("mouseleave", function() {
      if (isDragging) {
        isDragging = false;
        grid.classList.remove("dragging");
        updatePos();
        dragCurX = 0;
      }
    });
  }

  var resizeT;
  function onResize() {
    clearTimeout(resizeT);
    resizeT = setTimeout(function() {
      var w = window.innerWidth;
      if (
        lastAdvantagesResizeWidth !== null &&
        w === lastAdvantagesResizeWidth &&
        w <= 768
      ) {
        var section = getSection();
        if (!section) return;
        var containerR = section.querySelector(".container_advange");
        var gridR = containerR && containerR.querySelector(".advantages_grid");
        if (
          gridR &&
          gridR.getAttribute("data-school-advantages-bound") === "1" &&
          containerR
        ) {
          gridR.style.transition = "none";
          repositionSecondaryAdvantagesGrid(gridR, containerR);
          requestAnimationFrame(function() {
            requestAnimationFrame(function() {
              if (gridR) {
                gridR.style.transition =
                  "transform " + getDuration() + " cubic-bezier(0.4,0,0.2,1)";
              }
            });
          });
        }
        return;
      }
      lastAdvantagesResizeWidth = w;
      initSchoolAdvantagesSlider();
    }, 120);
  }

  function boot() {
    lastAdvantagesResizeWidth = window.innerWidth;
    initSchoolAdvantagesSlider();
    window.addEventListener("resize", onResize);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
